import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const assignGroups = async ({
	id,
	groupIds
}: {
	id: string;
	groupIds: (string | number)[];
}) => {
	await Promise.all(
		groupIds.map((groupId) =>
			cmsClient.post<unknown>(`/users/groups/${groupId}/members/`, {
				user_ids: [id]
			})
		)
	);
};

const useAssignGroups = () => {
	const queryClient = useQueryClient();

	const onSuccess = (
		_: unknown,
		variables: { id: string; groupIds: (string | number)[] }
	) => {
		toast.success(<CustomToast type="Success" message="Groups assigned" />, {
			hideProgressBar: true
		});

		queryClient.invalidateQueries(["person-profile", variables.id]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(assignGroups, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useAssignGroups;
